import { ReactNode, createContext, useContext, useMemo } from 'react';

export type ReadOnlyContextType = {
  isReadOnly: boolean;
};

const ReadOnlyContext = createContext<ReadOnlyContextType>({
  isReadOnly: false
});

type ReadOnlyProviderProps = ReadOnlyContextType & {
  children: ReactNode;
};

export const ReadOnlyProvider = (props: ReadOnlyProviderProps) => {
  const { children, isReadOnly } = props;

  const value = useMemo<ReadOnlyContextType>(() => ({ isReadOnly }), [isReadOnly]);

  return <ReadOnlyContext.Provider value={value}>{children}</ReadOnlyContext.Provider>;
};

export const useReadOnly = () => useContext(ReadOnlyContext);
